import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-filter",
  "use": "icon-filter-usage",
  "viewBox": "0 0 31 28.615",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 31 28.615\" id=\"icon-filter\">\r\n  <path id=\"icon-filter_路径_745\" data-name=\"路径 745\" d=\"M5.692,7.5H34.308a1.192,1.192,0,0,1,.906,1.968L24.054,22.5V34.923a1.192,1.192,0,0,1-1.72,1.069l-5.723-2.826a1.192,1.192,0,0,1-.664-1.069V22.5L4.787,9.468A1.192,1.192,0,0,1,5.692,7.5ZM31.717,9.885H8.283l9.761,11.4a1.192,1.192,0,0,1,.287.775v9.3L21.669,33V22.06a1.192,1.192,0,0,1,.287-.775Z\" transform=\"translate(-4.5 -7.5)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol